import React, { useEffect, useState } from "react";
import { Card, CardBody, Table, Button,Input } from "reactstrap";
import { toast } from "react-toastify";
import { getGroupedDesignationsApi } from "../../apiServices/designation.services";
import DesignationPermissionModal from "./DesignationPermissionModal";
import AppLoader from "../Common/AppLoader";

const DesignationPermissionTable = () => {
    const [search,setSearch] = useState("");
    const [page,setPage] = useState(1);
    const [totalPages,setTotalPages] = useState(1);
    const [loading,setLoading] = useState(true);
    const [designations,setDesignations] = useState([]);
    const [modal,setModal] = useState(false);
    const [selectedDesignation,setSelectedDesignation] = useState(null);
    
    const fetchDesignations = async()=>{
        try{
            if(!designations.length){
              setLoading(true);
            }
            const res = await getGroupedDesignationsApi({ search, page, });
            const finalDesignations = [];
            (res?.data?.data || []).forEach((department)=>{
            department.designationsActive?.forEach((d)=>{
                finalDesignations.push({
                ...d,
                departmentName:department.departmentName,
                });
            });
            });
            setDesignations(finalDesignations);
            setTotalPages(res?.data?.totalPages || 1);
        }catch(error){
            toast.error("Failed to load designations");
        }finally{
            setLoading(false);
        }
    };
    useEffect(()=>{
      const timer=setTimeout(fetchDesignations,400);
      return ()=>clearTimeout(timer);
    },[search,page]);
    const initialLoading = loading && !designations.length;

  return (
    <>
      <Card>
        <CardBody>

          <div className="mb-3">
            <h5 className="mb-0">
              Designation Permission Mapping
            </h5>
          </div>
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

            <Input
              placeholder="Search designation..."
              value={search}
              style={{maxWidth:"300px"}}
              onChange={(e)=>{
                setSearch(e.target.value);
                setPage(1);
              }}
            />

          </div>
          <div className="table-responsive">

            <Table className="table align-middle table-hover">

              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Designation</th>
                  <th>Department</th>
                  <th>Level</th>
                  <th width="150">
                    Permissions
                  </th>
                </tr>
              </thead>

             <tbody>
                {initialLoading ? (
                  <tr>
                    <td colSpan="5" className="text-center py-5">
                      <AppLoader compact />
                    </td>
                  </tr>
                ) : !designations.length ? (
                  <tr>
                    <td
                      colSpan="5"
                      className="text-center"
                    >
                      No Designations Found
                    </td>
                  </tr>
                ) : (
                  designations.map((item,index)=>(
                    <tr key={item._id}>

                      <td> {index + 1} </td>
                      <td> {item.title} </td>
                      <td> {item.departmentName || "-"} </td>
                     <td> { item.level ? item.level .split("_") .map(word=>word.charAt(0).toUpperCase()+word.slice(1)) .join(" ") : "-" } </td>

                      <td>

                        <Button size="sm" color="primary" onClick={()=>{
                            setSelectedDesignation(item);
                            setModal(true);
                          }}
                        >
                          <i className="mdi mdi-shield-key me-1" />
                          Manage
                        </Button>

                      </td>

                    </tr>
                  ))
                )}

              </tbody>

            </Table>
              <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                <Button size="sm" disabled={page===1} onClick={()=>setPage(p=>p-1)}> Prev </Button>
                <span> Page {page} / {totalPages} </span>
                <Button size="sm" disabled={page>=totalPages} onClick={()=>setPage(p=>p+1)} > Next </Button>
              </div>
          </div>

        </CardBody>
      </Card>

      <DesignationPermissionModal
        isOpen={modal}
        toggle={()=>{
          setModal(false);
          setSelectedDesignation(null);
        }}
        designation={selectedDesignation}
      />
    </>
  );
};

export default DesignationPermissionTable;